module.exports = __webpack_public_path__ + "img/intent_2.617e6093.png";